module.exports = __webpack_public_path__ + "img/frame (35).6e9ebf47.jpg";